const PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID;
const IS_DEV = process.env.NODE_ENV === 'development';

// Load Meta Pixel SDK (standard inline snippet)
if (PIXEL_ID && !IS_DEV) {
  (function(f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function() { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = '2.0';
    n.queue = [];
    t = b.createElement(e);
    t.async = !0;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');

  window.fbq('init', PIXEL_ID);
  // We do NOT call fbq('track', 'PageView') here — we fire it manually on route changes for SPA correctness
}

/**
 * Generate a UUID v4 for event deduplication with CAPI.
 */
function generateEventId() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

/**
 * Track a Meta Pixel event with deduplication support.
 * @param {string} eventName - Standard Meta event name (e.g., 'Purchase', 'InitiateCheckout')
 * @param {Object} [params={}] - Event parameters (value, currency, content_type, etc.)
 * @param {string} [eventID] - Optional event ID for dedup. Generated if not provided.
 * @returns {string} The event_id used (for passing to CAPI)
 */
export function trackMetaEvent(eventName, params = {}, eventID) {
  const id = eventID || generateEventId();

  if (IS_DEV) {
    console.log('[Meta Pixel DEV]', eventName, params, { eventID: id });
    return id;
  }

  if (typeof window.fbq === 'function') {
    window.fbq('track', eventName, params, { eventID: id });
  }

  return id;
}

/**
 * Track a custom Meta Pixel event.
 * Useful for funnel instrumentation that doesn't map cleanly to Meta's
 * standard event taxonomy.
 * @param {string} eventName
 * @param {Object} [params={}]
 * @param {string} [eventID]
 * @returns {string}
 */
export function trackMetaCustomEvent(eventName, params = {}, eventID) {
  const id = eventID || generateEventId();

  if (IS_DEV) {
    console.log('[Meta Pixel DEV custom]', eventName, params, { eventID: id });
    return id;
  }

  if (typeof window.fbq === 'function') {
    window.fbq('trackCustom', eventName, params, { eventID: id });
  }

  return id;
}

/**
 * Set user data for advanced matching (improves Event Match Quality).
 * Call after login with user email and ID.
 * @param {{ em?: string, external_id?: string, fn?: string, ln?: string }} userData
 */
export function setMetaUserData(userData) {
  if (IS_DEV) {
    console.log('[Meta Pixel DEV] setUserData', userData);
    return;
  }

  if (typeof window.fbq === 'function' && PIXEL_ID) {
    window.fbq('init', PIXEL_ID, userData);
  }
}
